import React, { useState, useEffect, useContext } from "react";
import { Link, withRouter } from "react-router-dom";
import { RootContext } from "../../RootContextProvider";
import qs from "query-string";
import { Input, message, Form, Button, Row, Col, Icon } from "antd";
import { verticalFormLayout } from "../../utils/forms";
import { signup } from "../../utils/auth";
import logoLS from "../../assets/logo/linksight-logo.svg";
import "./signup.css";
// import sideImage from "../../assets/background/background-signup.svg";

export const Signup = (props) => {
  const { history, location } = props;
  const { setToken } = useContext(RootContext);

  const [, setEmail] = useState();
  const [validationId, setValidationId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [host, setHost] = useState();
  const [form] = Form.useForm();
  useEffect(() => {
    const param = qs.parse(location.search, {
      ignoreQueryPrefix: true,
      decoder: (c) => c,
    });
    setValidationId(param.validationId);
    let email;
    if (param.email) {
      console.log(param);
      if (param.email.includes(" ")) {
        param.email = param.email.replace(" ", "+");
        email = param.email;
      } else {
        email = param.email;
      }
    }
    if (param.host) {
      setHost(param.host);
    }
    setEmail(email);
    form.setFieldsValue({
      email: email,
    });
    // eslint-disable-next-line
  }, [location.search]);

  const onFinish = async (values) => {
    setIsLoading(true);
    let validationID = validationId || null;
    try {
      const { token } = await signup(
        values.email,
        values.password,
        values.firstname,
        values.lastname,
        validationID
      );
      if (token) {
        console.debug("Signup local, reloading...");
        if (validationId) {
          setToken(token, true);
        } else {
          history.push("/validation");
        }
      }
    } catch (err) {
      console.log(err);
      message.error(err.error);
    } finally {
      setIsLoading(false);
    }
  };

  const onFinishFailed = async () => {
    console.log("It failed!");
  };

  return (
    <div className="signup-container">
      <Row>
        <Col xl={8} lg={8} md={24} sm={24} xs={24}>
          <div className="block-signin">
            <div className="heading-auth">
              <div className="logo-ls">
                <img src={logoLS} alt="logo local ranker" width="190px" />
              </div>
              {host ? (
                `Rejoignez ${host} dès maintenant sur Linksight`
              ) : (
                <span>Inscrivez-vous gratuitement à Linksight</span>
              )}
            </div>
            {/* <div className="signup-google">
          <a href="http://localhost:4000/auth/google">
            <button type="button" className="google-login">
              <img src={googleSvg} alt="logo google" />
              <span>S'inscrire avec Google</span>
            </button>
          </a>
        </div> */}
            <div className="signin-local">
              <Form
                {...verticalFormLayout}
                layout="vertical"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                form={form}
                // className="align-left"
              >
                <Row gutter={10}>
                  <Col span={12} className="full">
                    <Form.Item
                      // label="Prénom"
                      label="Prénom"
                      name="firstname"
                      rules={[
                        {
                          required: true,
                          message: "Insérez votre prénom",
                        },
                      ]}
                    >
                      <Input
                        autoFocus
                        className="auth-input"
                        placeholder="Elon"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12} className="full">
                    <Form.Item
                      // label="Prénom"
                      label="Nom"
                      name="lastname"
                      rules={[
                        {
                          required: true,
                          message: "Insérez votre nom",
                        },
                      ]}
                    >
                      <Input
                        autoFocus
                        className="auth-input"
                        placeholder="Musk"
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item
                  // className="no-margin"
                  label="Email"
                  name="email"
                  rules={[
                    { required: true, message: "Insérez votre email" },
                    {
                      type: "email",
                      message: "Veuillez insérer votre email",
                    },
                  ]}
                >
                  <Input className="auth-input" placeholder="elon@tesla.com" />
                </Form.Item>

                {/* <Form.Item
                  name="password"
                  label="Mot de passe"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez entrer votre mot de passe",
                    },
                  ]}
                >
                  <Input.Password  className="auth-input" />
                </Form.Item> */}
                <Form.Item
                  // className="no-margin"
                  label="Mot de passe"
                  name="password"
                  rules={[
                    { required: true, message: "Insérez votre mot de passe" },
                  ]}
                >
                  <Input
                    className="auth-input"
                    placeholder="*********"
                    type="password"
                  />
                </Form.Item>

                <Form.Item
                  // className="no-margin"
                  {...verticalFormLayout}
                >
                  <div className="forgot">
                    En vous inscrivant, vous acceptez les
                    <a
                      href="https://linksight.me/s/cgv"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {" "}
                      CGV de Linksight.
                    </a>
                  </div>
                  <Button
                    className="signup-button"
                    type="secondary"
                    htmlType="submit"
                    loading={isLoading}
                    size="large"
                    // disabled={hasErrors(getFieldsError())}
                  >
                    Créer un compte <Icon type="arrow-right" />
                  </Button>
                  <div className="signin-link">
                    <Link to="/signin"> J'ai déjà un compte</Link>
                  </div>
                </Form.Item>
              </Form>
            </div>
          </div>
        </Col>
        <Col
          xl={16}
          lg={16}
          md={24}
          sm={24}
          xs={24}
          className="block-image"
        ></Col>
      </Row>
    </div>
  );
};

export default withRouter(Signup);
